import { Col, Row } from 'antd';
import React from 'react';

import Layout from '../components/layout';
import SEO from '../components/seo';
import { Title } from '../components/styles';

export const Content404 = (
  <Row style={{ margin: '32px 0' }}>
    <Col
      xs={{ span: 22, offset: 1 }}
      md={{ span: 20, offset: 2 }}
      style={{ textAlign: 'center', marginBottom: 32 }}
    >
      <Title> 404: PAGE NOT FOUND </Title>
    </Col>

    <Col xs={{ span: 22, offset: 1 }} md={{ span: 9, offset: 2 }}>
      <p>
        Looks like we got lost on our way to that page. This could be because
        the page got towed away for repair, or because you typed it in wrong.
      </p>
      <p>
        <strong>
          Maybe these landmarks will help you find what you&apos;re looking for:
        </strong>
      </p>
      <p>
        <ul>
          <li>
            <a href="http://carolinas.aaa.com/#_ga=2.130998607.1100296215.1613424787-1919347687.1613424787">
              AAA Carolinas Homepage
            </a>
          </li>
          <li>
            <a href="https://living.acg.aaa.com/">AAA Living</a>
          </li>
          <li>
            <a href="https://carolinas.aaa.com/membership/plans/">
              Membership Levels & Pricing
            </a>
          </li>
          <li>Try using t​he site navigation</li>
        </ul>
      </p>
      <p>
        Still can&apos;t find what you&apos;re looking for? Hrmm... maybe try
        searching?
      </p>
    </Col>
    <Col xs={{ span: 22, offset: 1 }} md={{ span: 10, offset: 1 }}>
      <h3>​Contact an AAA Department</h3>
      <p>
        <ul>
          <li>
            Membership (New & Upgrades):
            <a href="tel:18665668635">1-866-566-8635</a>
          </li>
          <li>
            Travel:
            <a href="tel:18004448691">1-800-444-8691</a>
          </li>
          <li>
            AAA Auto Sales:
            <a href="tel:18006435339">1-800-643-5339</a>
          </li>
          <li>
            Health/Life Insurance:
            <a href="tel:18003334242">1-800-333-4242</a>
          </li>
          <li>
            Auto/Home Insurance:
            <a href="tel:1-(866) 228-8514">(866) 228-8514</a>
          </li>
          <li>
            Website Support:
            <a href="tel:18774651127">1-877-465-1127</a>
          </li>
          <li>
            Quality Assurance/Reimbursements:
            <a href="tel:18772823682">1-877-282-3682​​​</a>
          </li>
        </ul>
      </p>
    </Col>
  </Row>
);

const NotFoundPage = () => (
  <Layout>
    <SEO title="404: Not found" canonicalUrl="/404" />

    {Content404}
  </Layout>
);

export default NotFoundPage;
